// src/redux/codeSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { database } from "../../appWrite";
import { Query } from "appwrite";

// Define a type for the item
interface Item {
  id: string;
  images: string[]; // Array of image URLs
  title: string;
  description: string;
  // Add other properties as needed
}

// Define a type for the slice state
interface ItemState {
  allItems: Item[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

// Define the initial state using that type
const initialState: ItemState = {
  allItems: [],
  status: "idle",
  error: null,
};

// Async thunk to fetch the items from Appwrite
export const fetchItems = createAsyncThunk<Item[], void>(
  "items/fetchItems",
  async () => {
    const databaseId = "67ce8a4a0032e13c6368";
    const collectionId = "67dd738c000eb29fbaaf";

    const response = await database.listDocuments(databaseId, collectionId, [
      Query.limit(200),
      Query.offset(0),
    ]);

    // Map documents to the Item type
    const items: Item[] = response.documents.map((document) => ({
      id: document.$id,
      images: document.image || [], // Ensure images is an array
      title: document.title || "",
      description: document.description || "",

      // Map other fields if needed
    }));

    console.log(items);

    return items;
  }
);

const allItemSlice = createSlice({
  name: "items",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchItems.fulfilled, (state, action: PayloadAction<Item[]>) => {
        state.status = "succeeded";
        state.allItems = action.payload;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      });
  },
});

export default allItemSlice.reducer;
